export default {
  nav: {
    create: { name: "Outsource a Game Project" },
    menu: [
      // {
      //   name: "News Updates", link: '/blog',
      //   to: {
      //     name: "blog",
      //     params: {
      //       link: "https://multiverse-news.blogspot.com/",
      //       height: "1699px",
      //     }
      //   }
      // },
      {
        name: "About Us", link: '/about',
        to: {
          name: "about",
          params: {}
        }
      },
      // { name: "CAREERS", link: '/' },
      // { name: "contact", link: '/contact'},
    ]
  },
  home: {
    games: "Our Games",
    games_all: "All",
    awards: "Accolades",
    news: "News Updates",
    news_all: "All News",
    join_us: "Join Our Team",
    join_us_des: "Learn about our amazing culture.",
    join_us_des2: "Let's build worlds together.",
    join_us_des3: "We are always hiring.\nIf you are a talented game developer,\n please get in touch!\n All disciplines are welcome.",
    join_us_btn: "Contact us",
    more: "Learn More",
    explore:"Explore",
  },
  games: [
    { id: 'efas', name: 'Earth From Another Sun', link: 'https://store.steampowered.com/app/1067360/Pax_Autocratica/', des: 'Earth From Another Sun is a Rogue-Lite, Deck Building, FPS set in 2079. Fall into a fascinating alien world, fight through the waves of enemies that seek your demise, arm yourself with weapons and items scattered throughout the world. Get ready for a fight you won\'t forget.' },
    { id: 'sd', name: 'Seeking Dawn', link: 'https://www.seekingdawn.com', des: 'A vastly large sandbox-style sci-fi game for PC with VR support. Seeking Dawn is a survival RPG game with elements of action/adventure, and crafting. The game is set on a sprawling planet containing dangerous creatures and extraterrestrial mysteries. Stranded, the player and his team will have to scavenge for dwindling resources, explore the open world, craft powerful tools and equipment, and so much more!' },
    // { id: 'low', name: 'League Of Wannabes', link: 'http://low.multiverseinc.com', des: 'League of Wannabes is an awesome independent pixel mobile game. At its core you\'ll find a fusion of innovative Roguelike gameplay, sandbox style worlds, and a high degree of freedom that bring gamers a diverse and immersive gaming experience. The games story takes place in a parallel universe; one where people have caused serious damage to the environment, plundering natural resources and almost destroying the planet altogether. In this world, its inhabitants are divided into two classes – the surface society and the abandoned underground people, whom are under constant pressure and tyranny. Your role is the hero and your ultimate goal and hope for survival is to overthrow this oppressive regime by leading a secret rebellion.' },
    { id: 'df', name: 'Dream Flight', link: 'https://www.oculus.com/experiences/gear-vr/1013248532088752', des: 'This game is a melodic fantasy that soothes you with its sounds and visuals. The main character, a little girl, flies a paper plane with the hope of finding her lost friend. There are no violent or graphic themes in this mysterious dream world, allowing it to be suited for younger audiences, providing a calm and soothing environment, as well as an immersive and unique experience.' },
    // { id: 'sdlbe', name: 'Seeking Dawn LBE', link: 'https://www.seekingdawn.com', des: 'A vastly large sandbox-style sci-fi game for PC with VR support. Seeking Dawn is a survival RPG game with elements of action/adventure, and crafting. The game is set on a sprawling planet containing dangerous creatures and extraterrestrial mysteries. Stranded, the player and his team will have to scavenge for dwindling resources, explore the open world, craft powerful tools and equipment, and so much more!' },
  ],
  news: [
    { title: "利用Intel Graphics Performance Analyzers (Intel GPA) 优化Earth From Another Sun图形性能", type: "Earth From Another Sun", cover: "/images/news-3.png", link: "https://blogger.multiverseinc.com/2020/06/intel-graphics-performance-analyzers.html", created_at: "MAY 2ND, 2017", height: "9200px" },
    { title: "Working under the coronavirus quarantine", type: "Multiverse", cover: "/images/news-0.png", link: "https://multiverse-news.blogspot.com/2020/03/working-under-coronavirus-quarantine_6.html", created_at: "MAY 2ND, 2017", height: "2600px" },
    { title: "Earth From Another Sun at Unite Copenhagen 2019", type: "Earth From Another Sun", cover: "/images/news-1.png", link: "https://multiverse-news.blogspot.com/2019/09/earth-from-another-sun-at-unite.html", created_at: "Jun 19, 2017", height: "4000px" },
    // { title: "Seeking Dawn Valve Index Integration Update!", type: "Seeking Dawn", cover: "/images/news-2.png", link: "https://multiverse-news.blogspot.com/2019/11/seeking-dawn-valve-index-integration.html", created_at: "MAY 2ND, 2017", height: "1600px" },
    // { title: "Seeking Dawn Might Be The VR RPG Shooter That We\'ve All", type: "Seeking Dawn", cover: "/images/news-0.png", link: "http://vrthegamers.com/seeking-dawn-might-vr-rpg-shooter-weve-waiting/#.Wg7BWIyCyHt", created_at: "MAY 2ND, 2017" },
  ],
  footer: {
    title: "Subscribe to our newsletter for exclusive sneak peeks, updates, and more!",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    press: "Press kit"
  },
  subscribe: {
    title: "Get the latest news",
    btnTitle: "Subscribe"
  },
  about: {
    title: "We are fearless.",
    title2 : "We are makers.",
    story: {
      title: "Our Story",
      text: `      Multiverse began in 2016, when Canadian and French expatriates Freeman and Alexis came together around a shared dream: to create truly exceptional video games and build a studio loved by players around the world.

      We believe in creating "fun" before anything else. Though the exact meaning of "fun" is difficult to define, we know exactly what it feels like, being perhaps the most passionate and committed gamers ourselves. With a team of expert "fun" makers, we've produced a string of successful titles with thousands of players telling us how much fun they've been having.

      We also have a great passion for technology. Because of advancements in tech, video games have become so much fuller and more enjoyable over the years. We have made waves being one of the earliest virtual and augmented reality game creators. Our pursuit of elevated experience through advanced technology will always be relentless.

      But the one thing at the core of our success is that we listen to our players, and we listen very hard. We hear every word our players, critics, and potential players say about our games and act on this feedback to constantly improve. Our creations and services aren't perfect, but we can guarantee that they are always improving.

      If you possess top-notch game development or publishing skills and would like to have a warm, friendly chat with us, you are more than welcome to email us!`,
    },
    values: {
      title: "Our Values",
      list: [
        {
          title: "Selfless",
          des: "Always put team before self. \nAlways put customers before everything else.",
        },
        {
          title: "Tireless",
          des: "Relentless pursuit of high standards.\nPursuit for ever higher efficiency.",
        },
        {
          title: "Fearless",
          des: "Never be afraid of challenges. \nAlways look for novel solutions.",
        },
        {
          title: "Reliable",
          des: "Be an individual that teammates can depend on.\nBe a team that customers can depend on.",
        },
        {
          title: "Curious",
          des: "Insatiable hunger for learning and experimentation.\nEver-expanding expertise.",
        },
      ]
    }
  },
  contact: {
    title: "Get In Touch",
    sub_title: "现在就和我们聊一聊，不管你是不是正在找工作。",
    list: [
      {
        title: "Any Topic: ",
        text: "contact@multiverseinc.com",
      },
      {
        title: "Journalists: ",
        text: "pr@multiverseinc.com",
      },
      {
        title: "Careers: ",
        text: "careers@multiverseinc.com",
      },
      {
        title: "Address: ",
        text: "550 Rose Ave Venice, CA, 90291-2606",
      }
    ]
  },
}
